import Card from "components/card";
import { DataGrid } from "@mui/x-data-grid";
import ProductDrawer from "./ProductDrawer";
import React, { useState, useEffect } from "react";
import { getAllProducts } from "../functions";
import { Box, CircularProgress, Typography, Tooltip } from "@mui/material";
import { useDispatch } from "react-redux";
import ProductDelete from "./ProductDelete";
import { columns } from "../columns";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import ProductSummaryModalPDF from "./ProductSummary/ProductSummaryModal";
import SpecificationSheetMainModal from "./SpecificationSheet/SpecificationSheetMainModal";

const ProductTable = () => {
  const [open, setOpen] = useState(false);
  const [openSS, setOpenSS] = useState(false);
  const [openPDF, setOpenPDF] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [mode, setMode] = useState("POST");
  const [productData, setProductData] = useState(null);
  const [dataColumns, setDataColumns] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      let products = await getAllProducts();
      setProductData(products);
      let col = columns(
        setOpen,
        setMode,
        setOpenDelete,
        dispatch,
        setOpenPDF,
        setOpenSS
      );
      setDataColumns(col);
    };
    fetchData();
  }, [open, openDelete, dispatch]);

  const handleClosePDF = () => {
    setOpenPDF(false);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseSS = () => {
    setOpenSS(false);
  };

  return (
    <Box sx={{ height: "750px", width: "100%" }}>
      <SpecificationSheetMainModal open={openSS} handleClose={handleCloseSS} />
      <ProductSummaryModalPDF open={openPDF} handleClose={handleClosePDF} />
      <ProductDelete openDelete={openDelete} setOpenDelete={setOpenDelete} />
      <ProductDrawer open={open} handleClose={handleClose} mode={mode} />
      <Card extra={"w-full h-full p-5"}>
        <div className="relative flex items-center justify-end">
          <Tooltip title="Agregar Nuevo Producto" placement="top">
            <button
              onClick={() => {
                setOpen(true);
                setMode("POST");
              }}
              className="flex min-w-[80px] items-center
                         justify-center rounded-md bg-pink-500
                         px-3 py-2 text-white shadow-md transition hover:bg-pink-600
                         active:bg-pink-700"
            >
              <AddCircleIcon className="text-white" />
            </button>
          </Tooltip>
        </div>
        {productData ? (
          <DataGrid
            className="mt-8 h-max w-full dark:text-white"
            rows={productData || []}
            columns={dataColumns || []}
            autoPageSize
            rowsPerPageOptions={[5, 10, 20, 30, 50, 100]}
            checkboxSelection
            disableSelectionOnClick
            getRowHeight={() => "auto"}
          />
        ) : (
          <div className="flex justify-center pt-56">
            <CircularProgress color="primary" />
            <Typography>Cargando datos...</Typography>
          </div>
        )}
      </Card>
    </Box>
  );
};

export default ProductTable;
